const DEFAULT_ROOT_FONT_SIZE_PX = 16;

export default function pxToRem(px: number): string {
  return `${px / DEFAULT_ROOT_FONT_SIZE_PX}rem`;
}
